import { AccountBnpl } from "./accountBnpl.model";
import { OrderResponse } from "./orderResponse.model";


export class DetailBnpl {
  public bnplTransactionId: string;
  public balance: number;
  public commission: number;
  public order: OrderResponse;
  public accounts: AccountBnpl[]
  constructor(
  ) { }
}